import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import OrganigramaDataService from "./services/organigrama.service";
import Sidebar from './Sidebar';
import ExportSidebar from './ProSideBar';
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import { dtFormatter, dtForInputDate, PageHeader, getUserRoles } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewOrganigrama extends Component {  

  constructor(props) {
    super(props);
    this.onChangeOrganigrama = this.onChangeOrganigrama.bind(this);
    this.onChangeOrganigramaDescription = this.onChangeOrganigramaDescription.bind(this);
    this.onChangeOrganigramaNombre = this.onChangeOrganigramaNombre.bind(this);
    this.saveOrganigrama = this.saveOrganigrama.bind(this);
    //this.retrieveAreasN1 = this.retrieveAreasN1.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToOrganigramasList = this.goToOrganigramasList.bind(this);

    this.state = {
      id: null,
      nombreorganigrama: "",
      descripcionorganigrama: "",
      fechainicio: "",
      fechafin: "",
      submitted: false,
      organigramas: [],
      currentorganigrama: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToOrganigramasList() {
    window.location.assign('/organigramas');
  }

  handleValidations() {
    if (this.state.nombreorganigrama.length==0) {
      this.setState({errmessage:'Se requiere un nombre para el organigrama.'})
      this.setState({showerror:true})
      return;
    }
    this.saveOrganigrama();
  } 

  refreshList() {
    // is this actually needed?
    //this.retrieveAreasN1();
    this.setState({
        currentorganigrama: null,
        currentIndex: -1
    });
  }

  onChangeOrganigrama(e) {
    this.setState({
        nombreorganigrama: e.target.value
    });
  }

  onChangeOrganigramaDescription(e) {
    this.setState({
      descripcionorganigrama: e.target.value
    });
  } 

  onChangeOrganigramaNombre(e) {
    this.setState({
      nombreorganigrama: e.target.value
    });
  }   

  onChangeFechaInicio(e) {
    this.setState({
      fechainicio: e.target.value
    });
  } 
  
  onChangeFechaFin(e) {
    this.setState({
      fechafin: e.target.value
    });
  } 

  saveOrganigrama() {
    var data = {
      nombreorganigrama: this.state.nombreorganigrama,
      descripcionorganigrama: this.state.descripcionorganigrama             
    };

    OrganigramaDataService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          nombreorganigrama: response.data.nombreorganigrama,
          descripcionorganigrama: response.data.descripcionorganigrama          
        });
        this.setState({showerror:false});
        this.setState({errmessage:''});
        
        this.setState({succmessage:'El organigrama ha sido creado. Redirigiendo a la lista de organigramas...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
        window.location.assign("/organigramas");
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />       
        <Container>
          <Row className='mb-2'>
            <PageHeader/>
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Nuevo Organigrama</h5>
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre organigrama:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombreorganigrama" id="nombreorganigrama" onChange={this.onChangeOrganigramaNombre}></FormControl>
            </Col>                         

          </Row>

          <Row>
            <Col md={12}>
              <FormLabel className='mb-2'>Descripción organigrama:</FormLabel>       
              <FormControl type="text" name="descripcionorganigrama" id="descripcionorganigrama" onChange={this.onChangeOrganigramaDescription}></FormControl>
            </Col>
          </Row>
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-4'>
              <Button id='saveItem' className='btn-secondary' onClick={this.handleValidations}>Guardar organigrama</Button>            
              <Button className='m-2 btn-secondary' id='backToOrganigramasList' onClick={this.goToOrganigramasList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>  
          {this.state.showerror && (
            <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{this.state.errmessage}</p>
            </Alert>      
          )}
          {this.state.showsuccess && (
            <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{this.state.succmessage}</p>
            </Alert>      
          )}     
          { this.state.submitted ? (<Navigate push to="/organigramas"/>) : null }                                     
        </Container>
      </div>
      </>
    )      
  }
}

export default NewOrganigrama;